import React from 'react';
import {MenuList} from '../util/StyledElements';
import styled from 'styled-components';
import {TscStyles} from '@techsmith/tsc-cloud-style-guide';
import {t} from 'i18next';

const InviteBox = styled.div`
   border: 1px solid #ef8200;
   border-radius: 10px;
   background-color: #1a1f24;
   margin: 1rem 0.5rem 1rem 0.5rem;
   padding: 1rem 0 0.25rem 1.7rem;
`;

const ButtonLabel = styled.div`
   font-family: Figtree;
   font-weight: 600;
   font-size: 14px;
   line-height: 16px;
   color: ${TscStyles.color.text.lightMedium};
   text-transform: capitalize;
   padding-bottom: 1rem;
`;

const MenuListContainer = styled(MenuList)`
   margin-left: -0.75rem;
`;

const InvitationContainer: React.FC<IMenuRowProps> = ({subMenu}: IMenuRowProps) => (
   subMenu.length && (
      <InviteBox>
         <ButtonLabel>
            {t('sidebar.pendingInvitations').toUpperCase()}
         </ButtonLabel>

         {!!subMenu && (
            <MenuListContainer>
               {subMenu}
            </MenuListContainer>
         )}
      </InviteBox>
   )
);

export interface IMenuRowProps {
   subMenu?: React.JSX.Element[];
}

export default InvitationContainer;
